module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item !== undefined && _vm.item !== null) ? _c('div', {
    staticClass: "question-detail",
    attrs: {
      "id": "topExercise"
    }
  }, [_c('div', {
    staticClass: "item-question col-md-12"
  }, [(_vm.item.detailLink && _vm.item.detailLink !== undefined && _vm.item.detailLink.length > 0) ? _c('div', {
    staticClass: "big-audio"
  }, [_c('audio', {
    attrs: {
      "id": "player",
      "controls": "controls",
      "width": "50%"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.item.detailLink,
      "type": "audio/mp3"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "big-question"
  }, [_vm._v(_vm._s(_vm.$mycontroller.stripHtml(_vm.item.content)))])]), _c('div', {
    staticClass: "item-question-number"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('landing.exercise.question')) + " " + _vm._s(_vm.current) + "/" + _vm._s(_vm.total))])])]), _c('div', {
    staticClass: "item-question col-md-12"
  }, [_c('div', {
    staticClass: "small-question"
  }, [_vm._v(_vm._s(_vm.$mycontroller.stripHtml(_vm.item.detailContent)))])]), (_vm.item.detailType === 1) ? _c('div', {
    staticClass: "item-answer col-md-12"
  }, [(_vm.item.detailAnswers !== null) ? _c('div', {
    staticClass: "item-answer-me choosen"
  }, _vm._l((_vm.item.detailAnswers), function(itemAnswer, index) {
    return _c('div', {
      staticClass: "answer-charactor result-page",
      class: [_vm.item.detailStatus === 2 ? '' : (_vm.item.detailStatus === 1 && _vm.answerIDs !== null && _vm.answerIDs.includes(itemAnswer.id) ? 'success' : (_vm.item.detailStatus === 0 && _vm.answerIDs !== null && _vm.answerIDs.includes(itemAnswer.id) ? 'danger' : ''))]
    }, [_c('label', [_vm._v(_vm._s(_vm.$mycontroller.convertToAlphabet(index)) + ". " + _vm._s(_vm.$mycontroller.stripHtml(itemAnswer.content)))]), (_vm.item.detailStatus === 1 && _vm.answerIDs !== null && _vm.answerIDs.includes(itemAnswer.id)) ? _c('span', {
      staticClass: "material-icons format-icon"
    }, [_vm._v("done")]) : (_vm.item.detailStatus === 0 && _vm.answerIDs !== null && _vm.answerIDs.includes(itemAnswer.id)) ? _c('span', {
      staticClass: "material-icons format-icon"
    }, [_vm._v("clear")]) : _vm._e()])
  }), 0) : _vm._e()]) : _c('div', {
    staticClass: "item-answer col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('landing.exercise.answer')))]), (_vm.item.detailType === 2 && _vm.item.detailStatus === 1 && _vm.$mycontroller.stripHtml(_vm.item.detailValueContent).length > 0) ? _c('div', {
    staticClass: "item-answer-me answer-text success",
    domProps: {
      "innerHTML": _vm._s(_vm.rawHtml(_vm.item.detailValueContent))
    }
  }) : (_vm.item.detailType === 2 && _vm.item.detailStatus === 0 && _vm.$mycontroller.stripHtml(_vm.item.detailValueContent).length > 0) ? _c('div', {
    staticClass: "item-answer-me answer-text danger",
    domProps: {
      "innerHTML": _vm._s(_vm.rawHtml(_vm.item.detailValueContent))
    }
  }) : (_vm.item.detailType === 2 && _vm.item.detailStatus === 2) ? _c('div', {
    staticClass: "item-answer-me answer-text",
    domProps: {
      "innerHTML": _vm._s(_vm.rawHtml(_vm.item.detailValueContent))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "item-result"
  }, [_c('div', {
    staticClass: "item-result-top",
    attrs: {
      "id": "topSystemAnswer"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('landing.exercise.answer_sys')))]), (_vm.item.detailType === 2) ? _c('div', {
    staticClass: "item-answer-system",
    domProps: {
      "innerHTML": _vm._s(_vm.rawHtml(_vm.item.detailValue))
    }
  }) : (_vm.item.detailType === 1) ? _c('div', {
    staticClass: "item-answer-system",
    domProps: {
      "innerHTML": _vm._s(_vm.getAnswerCorrect(_vm.item.detailAnswers))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "item-result-center"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('landing.exercise.explain')))]), _c('div', {
    staticClass: "item-result-explain",
    domProps: {
      "innerHTML": _vm._s(_vm.rawHtml(_vm.explain))
    }
  })]), _c('div', {
    staticClass: "item-result-bottom",
    attrs: {
      "id": "topSystemRelate"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('landing.exercise.relate')))]), _c('div', {
    staticClass: "box-owl-carousel"
  }, [(_vm.lstLessons && _vm.lstLessons !== null) ? _c('carousel', {
    key: _vm.refresh,
    ref: "owlCarousel",
    staticClass: "owl-carousel",
    attrs: {
      "center": true,
      "responsive": {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        768: {
          items: 3
        }
      },
      "autoplay": true,
      "dots": false,
      "nav": false
    }
  }, [_c('template', {
    slot: "prev"
  }, [_c('button', {
    staticClass: "prev"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])]), _vm._l((_vm.lstLessons), function(lesson, index) {
    return _c('FrontItem', {
      key: index,
      ref: "frontItem",
      refInFor: true,
      attrs: {
        "lesson": lesson,
        "url": _vm.getLinkMore(),
        "obj_id": lesson.id
      }
    })
  }), _c('template', {
    slot: "next"
  }, [_c('button', {
    staticClass: "next"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])])], 2) : _vm._e()], 1)])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "box-button-help"
  }, [_c('div', {
    staticClass: "item-fixed-button"
  }, [_c('div', {
    staticClass: "item-button",
    class: [_vm.isMobile() ? 'click-button' : 'hover-button'],
    on: {
      "click": function($event) {
        return _vm.gotoElement('topExercise')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/faces/ic_noidungcauhoi_24px@2x.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('landing.exercise.buttons.button1')))])]), _c('div', {
    staticClass: "item-button",
    class: [_vm.isMobile() ? 'click-button' : 'hover-button'],
    on: {
      "click": function($event) {
        return _vm.gotoElement('topSystemAnswer')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/faces/ic_idea_24px@2x.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('landing.exercise.buttons.button2')))])]), _c('div', {
    staticClass: "item-button",
    class: [_vm.isMobile() ? 'click-button' : 'hover-button'],
    on: {
      "click": function($event) {
        return _vm.gotoElement('topSystemRelate')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/faces/ic_link_24px@2x.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('landing.exercise.buttons.button3')))])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9aba0226","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/Exercise/questionResult.vue
// module id = 1633
// module chunks = 0